/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/damur/"

const DAMUR: CommunityData = {
  code: "damur",
  inviteCode: "damur",
  name: "DAMUR",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/dam-030`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[160px] h-[49px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[49px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      // CUSTOM OVERRIDE — aside: remove gap/paddings, no bg, keep right border.
      // Post-gen doc: keep asideStyles minimal, avoid bg overrides (no-bg via asideBg).
      asideBg: "#39ff15",
      asideStyles: "!gap-0 !py-0 border-r border-[#000000]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#39ff15] border border-[#000000] rounded-[999px] px-[18px] py-[18px] !text-[#000000] font-['OswaldMedium'] !text-[16px] uppercase !text-center leading-[100%]",
    },
    navigation: {
      iconsColor: "#222222",
      // Post-gen doc default unless specified otherwise
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#000000]",
      // Post-gen doc: opacity treatment, no explicit bg (inherits from aside)
      item: "font-['OswaldDemiBold'] text-[17px] text-[#222222] uppercase text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      // CUSTOM OVERRIDE — container copied from reference (bg swapped to #ffffff)
      container: "!bg-[#ffffff] !pb-8",
      titles: "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        // CUSTOM OVERRIDE — sectionContainer copied from reference
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        // CUSTOM OVERRIDE — scrollMenu copied from reference
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // Post-gen doc: no border on item card; overflow hidden; gap handled by scrollMenu
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          // Post-gen doc: vertical-only padding so text aligns flush with media edge
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        // CUSTOM OVERRIDE — scrollMenu copied from reference
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          // Post-gen doc: no border on item card; overflow hidden; gap handled by scrollMenu
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          // Post-gen doc: mobile stacked → py-4 px-0; desktop row → px-4 py-0 (title aligns to image top)
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['OswaldRegular'] text-[14px] text-left leading-[120%] mt-2",
          location:
            "text-[#000000] font-['OswaldRegular'] text-[14px] text-left leading-[120%] mt-1",
          date: "text-[#000000] font-['OswaldRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['OswaldBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[18px] text-left leading-[120%]",
        // Post-gen doc: shop images have no border
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    // Derived from web styles per .agents/skills/onboard-community/references/wm.md#coming-soon-page inheritance principle:
    // logo=web menu logo, left bg=contentBg, title=landing module title, body=shop description,
    // CTA=web primary button, disclaimer=landing date text, hero=invite landing bg media.
    comingSoon: {
      bgColor: "#ffffff",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#ffffff]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[140px] h-[43px] sm:w-[160px] sm:h-[49px] object-contain",
      },
      werzLogoColor: "#191818",
      title: "font-['OswaldBold'] text-[28px] uppercase leading-[110%] text-[#000000]",
      text: "font-['OswaldRegular'] text-[15px] leading-[120%] text-[#000000]",
      button:
        "font-['OswaldMedium'] text-[16px] uppercase leading-[100%] p-4 bg-[#39ff15] border border-[#000000] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['InterRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#222222]",
        border: "#000000",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['InterRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OswaldRegular'] text-[12px] leading-[120%] text-[#000000]",
      skipButton: "font-['InterRegular'] text-[14px] leading-[120%] text-[#222222] cursor-pointer",
      modal: {
        container: "bg-[#ffffff] px-[40px] py-[48px]",
        title:
          "font-['OswaldBold'] text-[24px] uppercase leading-[110%] text-[#000000] text-center",
        text: "font-['OswaldRegular'] text-[15px] leading-[120%] text-[#000000] text-center",
        width: "w-[358px]",
        backdrop: "",
        otpInput:
          "!w-[40px] !h-[50px] text-black bg-white font-['OswaldMedium'] text-[16px] leading-[120%] text-center",
        otpBorder: "#000000",
        otpBorderFocus: "#000000",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#000000]",
        // Post-gen doc: event media has no border
        media: "sm:!w-[320px] w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#39ff15] border border-[#000000] rounded-[999px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['OswaldMedium'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['OswaldBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['OswaldBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        // CUSTOM OVERRIDE — map overflow-hidden + rowGap 10
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['OswaldBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['OswaldBold'] text-[28px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[12px] py-[12px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          // Post-gen doc: tickets separated by border-b, vertical padding only, no margin bottom
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#000000] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#000000] font-['OswaldRegular'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[12px] py-[12px] gap-x-[16px] !w-fit",
          button:
            "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[12px] py-[12px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
    // Mapped per .agents/skills/onboard-community/references/wm.md#links-page: fill/border from wmContentContainer (#ffffff/#000000),
    // headers = mmNewsItemTitle sizing + wmLandingTitle color, body = wmBodyText, buttons = wmTicketButton.
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`,
      bgMobile: `${S3_PREFIX}web-background-non-member.jpg`,
      bgColor: "#ffffff",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ffffff]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#000000] object-cover",
        name: "text-[#000000] font-['OswaldBold'] text-[24px] uppercase text-center mt-4 mb-1",
        location: "text-[#222222] font-['OswaldRegular'] text-[16px] text-center mb-2",
        description:
          "text-[#000000] font-['OswaldRegular'] text-[16px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[16px] py-[16px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff]",
          title: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-center mb-1",
          text: "text-[#000000] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
          button:
            "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[16px] py-[16px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000]",
          duration: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          name: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border border-[#000000]",
          name: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#000000] text-[#000000] font-['OswaldBold'] text-[14px] uppercase text-center",
          duration: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          location: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          button:
            "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[16px] py-[16px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['OswaldMedium'] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['OswaldMedium'] text-[14px] text-left",
            link: "text-[#222222] font-['OswaldRegular'] text-[12px] leading-[120%] text-left",
            status:
              "text-[#000000] font-['OswaldBold'] text-[14px] uppercase leading-[100%] text-left",
            button:
              "bg-[#ffffff] border border-[#000000] rounded-[999px] px-[16px] py-[16px] text-[#000000] font-['OswaldMedium'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#222222] font-['OswaldRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        container: "flex flex-col gap-4",
        header: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-center mb-[10px]",
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000]",
          coverUrl: "overflow-hidden m-2",
          duration: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          liveType: "text-[#222222] font-['OswaldRegular'] text-[12px] leading-[120%] text-left",
          liveTypeCircle: "bg-[#222222]",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#000000",
          start: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          title:
            "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#222222] font-['OswaldRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
        header: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000]",
          name: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#222222] font-['OswaldRegular'] text-[14px] leading-[120%] text-left",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#222222] font-['OswaldRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
        header: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000]",
          name: "text-[#000000] font-['OswaldBold'] text-[16px] uppercase text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#000000] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#191818",
        text: "text-[#222222] font-['OswaldRegular'] text-[12px] text-left",
      },
    },
  },
}

export default DAMUR
